
const translations = {

    "en" : {
        "middleBarHead"   : "",
        "alertBigPrivacy" : {
            "title" : "Cookie Preferences",
            "text"  : "By clicking “Accept all,” you enjoy the best browsing experience.",
        },
        "acceptAll"   : "Accept all",
        "denyAll"     : "Deny all",
        "personalize" : "Personalize",
    },

    "fr" : {
        "middleBarHead": "",
        "alertBigPrivacy": {
            "title": "Préférences Cookies",
            "text": "En cliquant sur 'Tout accepter', vous profitez de la meilleure expérience de navigation.",
        },
        "acceptAll"   : "Tout accepter",
        "denyAll"     : "Tout refuser",
        "personalize" : "Personnaliser",
    }
} ;

export { translations };